<template>
    <BaseModal
        :id="'static-update'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <!-- <div class="row space-button-2">
                    <pre>
                        {{ single_object }}
                    </pre>
                </div> -->
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        "breadcrumb",
        'parent_id',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        "array_options",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format:    FormResources.form_format,
        }
    },
    
    methods:{},

    mounted(){

    }
    
}
</script>